<template>
    <div>
        <!-- Editar Contrato Modal -->
        <div class="modal fade" id="editarContratoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar Contrato</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="lista">
                        <div v-if="contratos && contratos.length">
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(contrato, icx) in contratos" :key="icx" @click="atualizar_contrato(contrato)">
                                    <div>
                                        {{ contrato.search }}
                                    </div>
                                    <div>
                                        #{{ contrato.id_contrato_operadora }}
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() {
        return {
            lista: [], 
            contratos: [], 
        }       
    },

    methods: { 
        
        abrir (guias, contrato) { 
            this.lista = _.cloneDeep(guias);

            console.log('contrato', contrato);

            this.$util.load(this, { 
                service: 'operadoras',
                func: 'obter_contratos', 
                parms: { 
                    id_contrato_operadora: contrato.id_contrato_operadora 
                },
                loadTo: res => { 
                    this.contratos = res.lista;
                }
            })

            $('#editarContratoModal').modal('show');
        },

        atualizar_contrato (contrato) { 
            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'recalc_contratos', 
                dados: { 
                    guias: this.lista.map(item => { return { id_guia: item.id_guia }; }),
                    id_contrato_operadora: contrato.id_contrato_operadora
                },
                modal: 'editarContratoModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }

    }
}
</script>
